/**
 *  Base class for components
 *  @module Widgets
 *  @author Livescore
 *  @copyright 2021 livescore
 */

import * as $ from 'jquery';
import { isUndefined } from 'lodash-es';
import APP_CONFIG from '@config/app.config';
import { Directive } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';

import { DemoService } from '../services/demo.service';

@Directive()
export class BaseComponent {
    protected auth: boolean = false;

    public loaded: boolean = false;

    public loadedError: boolean = false;

    public noTitle: boolean = false;

    public loadedErrorReason: string = 'error_match';

    protected demoParent: DemoService;

    public num: number;

    public constructor(demo: DemoService) {
        this.demoParent = demo;
        $('body').addClass('widget-body');
    }

    public ngOnInit(): void {
        $('#loader').hide();
        $('body').removeClass('loader-active');
    }

    public trackByFn(index: number, item: Record<string, any>): number | null {
        if (isUndefined(item)) {
            return null;
        }
        return item.id;
    }

    public trackByIndex(index: number): number {
        return index;
    }

    protected setTitle(router: ActivatedRoute): void {
        router.paramMap.subscribe((param: ParamMap) => {
            if (param.has('notitle')) {
                this.noTitle = true;
            }
        });
    }

    /**
     * Error load data
     */
    protected error(reason: string = 'error_match'): void {
        this.loaded = true;
        this.loadedError = true;
        this.loadedErrorReason = reason;
    }

    /**
     * Successload data
     */
    protected finished(): void {
        this.loaded = true;
        this.loadedError = false;

        this.demoParent.widgetLoader.emit(true);
    }

    protected checkEmpty<T extends Record<string, any>>(): (data: T) => Observable<T | string> {
        return (data: T): Observable<T> => {
            if (data.home.form.length === 0 || data.away.form.length === 0) {
                return throwError('empty-data');
            }
            return of(data);
        };
    }

    /**
     * @listens BaseComponent#imageError
     * Listen to image error and load defautl image
     */
    public imageError(e: Record<string, any>, type = 'team'): void {
        const img = type === 'avatar' ? APP_CONFIG.defaultAvatar : APP_CONFIG.defaultLogo;
        e.target.src = img;
    }
}
